(function () {
    var EventDetailCtrl = (function () {
        function EventDetailCtrl() {
            this.init.apply(this, arguments);
        }

        EventDetailCtrl.prototype = {
            init: function ($scope, $state, $rootScope, $stateParams, localStorageService, $mdDialog, $interval, MKioskService, $message, $q, $timeout, AttackmentService, $translationService) {
                $scope.vm = this;
                this.$rootScope = $rootScope;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.localStorageService = localStorageService;
                this.$mdDialog = $mdDialog;
                this.$interval = $interval;
                this.MKioskService = MKioskService;
                this.$message = $message;
                this.$q = $q;
                this.$timeout = $timeout;
                this.AttackmentService = AttackmentService;
                this.$translationService = $translationService;

                this.id = this.$stateParams.id;
                this.$element = $("#internal-event-detail-page");

                this.comment = {
                    EventId: this.id
                };
                this.item = {};
                this.loadData(this.id).then(angular.bind(this, function (item) {
                    this.item = item;

                    _.each(item.Comments, function (comment) {
                        _.each(comment.Attachments, function (attachment) {
                            attachment.iconClass = this.AttackmentService.getIcon(attachment.DownloadUrl);
                            attachment.isPhoto = this.AttackmentService.isPhoto(attachment.DownloadUrl);
                        }, this);
                    }, this);

                    //Set Title
                    if (this.$stateParams.title) {
                        // NF-894: allow pass title to the state by parameter to show directly
                        this.title = this.$stateParams.title;
                    } else {
                        this.title = this.$translationService.getTranslation('EventDetails').toUpperCase();
                    }
                    //Mark all the unread comments for this user on this event as read.
                    this.markEventAsRead(this.id);

                    this.fileItemWidth = this.getFileItemWidth();
                }), this.$message.error);

                this.bindEvents();
                this.watch();
            },
            bindEvents: function () {
                $(window).bind("resize.eventdetail", angular.bind(this, function () {
                    this.fileItemWidth = this.getFileItemWidth();
                    this.safeApply();
                }));
            },
            watch: function () {
                this.$scope.$on("$destroy", function () {
                    $(window).unbind("resize.eventdetail");
                });
            },
            back: function () {
                var routerName = "internal.events";
                var preParams = null;
                if (this.$stateParams.prevState) {
                    routerName = this.$stateParams.prevState;
                    
                    if (this.$stateParams.preParams) {
                        preParams = JSON.parse(this.$stateParams.preParams);
                    }
                }
                    
                this.$state.go(routerName, preParams);
            },
            refreshData: function () {
                return this.loadData(this.id).then(angular.bind(this, function (item) {
                    this.item = item;
                }));
            },
            loadData: function (eventId) {
                return this.MKioskService.getEvent(eventId);
            },
            markEventAsRead: function (eventId) {
                return this.MKioskService.markEventAsRead(eventId);
            },
            send: function () {
                if (!this.comment.Text)
                    return;
                this.MKioskService.adEventComment(this.comment).then(angular.bind(this, function () {
                    this.comment.Text = "";
                    this.commentEl.val("");
                    autosize.update(this.commentEl[0]);
                    this.refreshData().then(angular.bind(this, function () {
                        //Wait keyboard hide to scroll to bottom
                        this.$timeout(()=> {
                            this.scrollBottom();
                        }, 500);
                    }))
                }), this.$message.error);
            },

            isFileType: function (fileName, exts) {
                return _.find(exts, function (ext) {
                    return fileName.toLocaleLowerCase().indexOf("." + ext) != -1;
                });
            },
            /**
             * Get class icon to display icon of file
             * @param name
             * @returns {*}
             */
            getIcon: function (name) {
                //Pdf
                if (this.isFileType(name, ['pdf']))
                    return 'fa-file-pdf-o';
                //isPhoto
                if (this.isFileType(name, ['jpg', 'jpeg', 'psd', 'png', 'tiff', 'bmp', 'gif', 'ico']))
                    return 'fa-file-image-o';
                //isExcel
                if (this.isFileType(name, ['xls', 'xlsx']))
                    return 'fa-file-excel-o';
                //isWord
                if (this.isFileType(name, ['doc', 'docx']))
                    return 'fa-file-word-o';
                //isPresentation
                if (this.isFileType(name, ['pps', 'ppt', 'pptx']))
                    return 'fa-file-powerpoint-o';
                //isText
                if (this.isFileType(name, ['txt', 'text']))
                    return 'fa-file-text-o';
                //isArchive
                if (this.isFileType(name, ['zip', 'zar', 'tar', '7z', 'gz']))
                    return 'fa-file-archive-o';
                return 'fa-file-o';
            },            
            isFileImage: function (fileName) {
                return this.getIcon(fileName) === "fa-file-image-o";
            },
            showAttachmentDetail: function (attachment, attachments, ev) {
                ev.preventDefault();
                if (this.isFileImage(attachment.DownloadUrl)) {
                    this.showImageViewer(attachment, attachments, ev);
                } else {
                    if(window['cordova']){
                        window['cordova'].InAppBrowser.open(attachment.DownloadUrl, '_system');
                    } else {
                        window.open(attachment.DownloadUrl,'_blank');
                    }
                }
            },
            showImageViewer: function (attachment, attachments, ev) {
                this.$mdDialog.show({
                    controller: 'ImageViewerController',
                    templateUrl: 'js/internal/imageviewer/imageviewer.view.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true,
                    locals: {
                        attachment: attachment,
                        attachments: attachments
                    },
                    onComplete: function (scope, element) {

                        //Add class to fix height of md-dialog
                        element.addClass("md-dialog-imageviewer");
                        scope.vm.ready();
                    }
                });
            },
            getFileItemWidth: function () {
                var number = ($(window).width() - 64) / 100;
                number = Math.round(number);
                return (1 / number) * 100;
            },
            safeApply: function (fn) {
                var phase = this.$scope.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof(fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$scope.$apply(fn);
                }
            },
            initTextarea: function(){
                //auto resize textarea
                var commentEl = this.$element.find("#comment");
                autosize(commentEl[0]);
                this.commentEl = commentEl;
            },
            scrollBottom: function(){
                let scroller = this.$element.find('#comment-container')[0];
                scroller.scrollTop = scroller.scrollHeight;
            }
        };
        EventDetailCtrl.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'localStorageService', '$mdDialog', '$interval', 'MKioskService', '$message', '$q', '$timeout', 'AttackmentService', '$translationService'];
        return EventDetailCtrl;
    }());
    angular.module('internal.eventdetail').controller('EventDetailCtrl', EventDetailCtrl)
})();


